import React from "react";
import { ProcedimentoRealizado } from "../../../../../interfaces/entities/Reembolso/ProcedimentoRealizado";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import { formatStringToReaisNumberFormat } from "../../../../../utils/MoneyFormat";
import "./styles.css";

const ProcedsDataCard: React.FC<{ lstProceds: ProcedimentoRealizado[] }> = ({ lstProceds }) => {

  const { fontSizeStyleAccessibility } = useAccessibility();

  const applyRadiusBottom = (indexProced: number) => { //Aplica estilo radius-bottom para o último procedimento da lista, fechando o contorno do card
    return indexProced + 1 === lstProceds.length ? 'radius-bottom' : '';
  }

  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card">
        <div className="registration-data-row">
          <span style={fontSizeStyleAccessibility} className="registration-data-title">Dados dos procedimentos</span>
        </div>
        {lstProceds.map((proced, index) => (
          <React.Fragment key={index}>
            <div className={`registration-data-row registration-data-row-secondary`}>
              <span style={fontSizeStyleAccessibility} className="registration-data-key">Procedimento {index + 1}</span>
              <span style={fontSizeStyleAccessibility} className="registration-data-value">{''}</span>
            </div>
            <div className={`registration-data-row`}>
              <span style={fontSizeStyleAccessibility} className="registration-data-key">Procedimento</span>
              <span style={fontSizeStyleAccessibility} className="registration-data-value">{proced.procedimento?.descr}</span>
            </div>
            <div className={`registration-data-row registration-data-row-secondary`}>
              <span style={fontSizeStyleAccessibility} className="registration-data-key">Quantidade</span>
              <span style={fontSizeStyleAccessibility} className="registration-data-value">{proced.quantidade}</span>
            </div>
            <div className={`registration-data-row ${applyRadiusBottom(index)}`}>
              <span style={fontSizeStyleAccessibility} className="registration-data-key">Valor solicitado</span>
              <span style={fontSizeStyleAccessibility} className="registration-data-value">R$ {formatStringToReaisNumberFormat(proced.valorPago)}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default ProcedsDataCard;